import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TagsService } from '../../../core/services/tagging/tags.service';
import { ProductTagTypeListModel } from '../../../core/models/tagging/product-tag-type.model';
import { Pageable } from '../../../core/models/common/pageable.model';
import {
  createPaginationState,
  setPaginationLoading,
  updatePaginationFromResult,
} from '../../../core/helpers/pagination-state.helper';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';

@Component({
  selector: 'app-campaign-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LoadingComponent,
    AlertComponent,
    PaginationComponent,
    ButtonComponent,
  ],
  templateUrl: './campaign-list.component.html',
  styleUrl: './campaign-list.component.scss',
})
export class CampaignListComponent implements OnInit {
  error: string | null = null;
  templates: ProductTagTypeListModel[] = [];
  readonly paginationState = createPaginationState();

  constructor(private readonly tagsService: TagsService) {}

  ngOnInit(): void {
    this.onPageChange(0, this.paginationState().itemsPerPage);
  }

  onPageChange = (page: number, pageSize: number): void => {
    setPaginationLoading(this.paginationState, true);
    this.error = null;

    this.tagsService.listTypes(page, pageSize).subscribe({
      next: (result: Pageable<ProductTagTypeListModel>) => {
        this.templates = result.content ?? [];
        const normalized = {
          content: result.content ?? [],
          page: {
            page: result.page?.page ?? page,
            total: result.page?.total ?? 0,
            size: result.page?.size ?? pageSize,
          },
        };
        updatePaginationFromResult(this.paginationState, normalized, pageSize);
      },
      error: () => {
        this.error = 'Falha ao carregar os templates de etiquetas.';
        setPaginationLoading(this.paginationState, false);
      },
    });
  };
}
